import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ConfirmationModalConfig } from '../../../shared/components/confirmation-modal/confirmation-modal.component';

@Component({
    selector: 'gtw-client-backbutton-action',
    templateUrl: './client-backbutton-action.component.html',
    styleUrls: ['./client-backbutton-action.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ClientBackbuttonActionComponent implements OnInit {

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  modalConfig: ConfirmationModalConfig = {
    title: 'Change Client',
    message: 'You might have hit back button, which was for different client. Are you sure you want to switch?',
    iconClass: 'fa fa-sign-out',
    iconColor: 'txt-color-orange-dark',
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
    confirmButtonClass: 'btn-danger',
    cancelButtonClass: 'btn-default',
    showCancelButton: true,
    showConfirmButton: true,
    animationClass: 'animated fadeIn fast',
    loading: false
  };

  constructor() {}

  ngOnInit(): void {}

  onConfirm(): void {
    this.requestGridUpdate.emit('refresh');
  }

  onCancel(): void {
    this.cancel();
  }

  cancel(): void {
    const updateEvent = new CustomEvent('request-grid-update', {
      detail: 'cancel',
      bubbles: true
    });
    if (document.querySelector('gtw-client-backbutton-action-ce')) {
      document.querySelector('gtw-client-backbutton-action-ce')?.dispatchEvent(updateEvent);
    }
  }
}
